/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LegalPersonTags {
    TARGET = 'TARGET',
    FUND = 'FUND',
    CO_INVESTOR = 'CO_INVESTOR',
    EXTERNAL_LENDER = 'EXTERNAL_LENDER',
    BID_CO = 'BID_CO',
    SPV = 'SPV',
    PC_MANAGED = 'PC_MANAGED',
}
